import {
	Box,
	Button,
	FormControl,
	FormErrorMessage,
	FormLabel,
	Input,
	Link,
	Text,
} from '@chakra-ui/react';
import React, { useContext, useEffect } from 'react';
import { Link as ReactRouterLink, useHistory } from 'react-router-dom';
import { useForm } from 'react-hook-form';

import { loginResolver } from '../../utils/validator/loginResolver';
import { auth } from '../../utils/firebase';
import Store from '../../utils/Store';
import { FaFacebook, FaGoogle } from 'react-icons/fa';

const Login = () => {
	const {
		handleSubmit,
		register,
		formState: { errors, isSubmitting },
		setError,
		clearErrors,
	} = useForm({ resolver: loginResolver });

	const { user, handleFbSignIn, handleGoogleSignIn } = useContext(Store);
	// const { user } = value;

	const history = useHistory();

	const onSubmit = ({ email, password }) => {
		clearErrors('API_ERROR');
		// firebase
		auth
			.signInWithEmailAndPassword(email, password)
			.then(() => {
				history.push('/');
				// console.log(email);
			})
			.catch((err) => {
				setError('API_ERROR', {
					message: 'Email or Password would be Invalid',
				});
			});
	};

	// check user login or not
	useEffect(() => {
		if (user) {
			history.push('/');
			// console.log(user);
		}
	}, [user, history]);

	return (
		<Box
			width='100%'
			minH='100vh'
			background='gray.200'
			d='flex'
			alignItems='center'
			justifyContent='center'
		>
			<Box
				width={{ base: '90%', md: '40%', lg: '30%' }}
				shadow='lg'
				background='white'
				p={12}
				rounded={6}
			>
				<form onSubmit={handleSubmit(onSubmit)}>
					<FormControl isInvalid={errors.email}>
						<FormLabel htmlFor='email'>Email</FormLabel>
						<Input
							type='email'
							name='email'
							placeSelf='Enter your Email'
							{...register('email')}
						/>
						<FormErrorMessage>
							{errors.email && errors.email.message}
						</FormErrorMessage>
					</FormControl>

					<FormControl mt='2' isInvalid={errors.password}>
						<FormLabel htmlFor='password'>Password</FormLabel>
						<Input
							type='password'
							name='password'
							placeSelf='Enter your Password'
							{...register('password')}
						/>
						<FormErrorMessage>
							{errors.password && errors.password.message}
						</FormErrorMessage>
					</FormControl>

					<Box mt='5' color='red.400'>
						{errors.API_ERROR && errors.API_ERROR.message}
					</Box>
					<Button
						isLoading={isSubmitting}
						type='submit'
						mt='4'
						w='100%'
						colorScheme='messenger'
					>
						Log In
					</Button>
					<Text textAlign='center' p='2' size='xs'>
						<Link as={ReactRouterLink} to='/signup' color='gray.500'>
							Create account?
						</Link>
					</Text>
				</form>
				<Text textAlign='center'> or</Text>
				<Button
					isLoading={isSubmitting}
					type='submit'
					mt='2'
					w='100%'
					colorScheme='red'
					onClick={handleGoogleSignIn}
					leftIcon={<FaGoogle />}
				>
					Sign In With Google
				</Button>
				<Button
					isLoading={isSubmitting}
					type='submit'
					mt='2'
					w='100%'
					colorScheme='facebook'
					leftIcon={<FaFacebook />}
					onClick={handleFbSignIn}
				>
					Sign In With Facebook
				</Button>
			</Box>
		</Box>
	);
};

export default Login;
